import { JourneyConnected } from "../JourneyView/Journey"
import s from "./SingleJourneyView.module.scss"

type SingleJourneyViewProps = { journeyId: string }
export const SingleJourneyViewConnected = ({
  journeyId,
}: SingleJourneyViewProps) => {
  return (
    <div className={s.view}>
      <div className={s.view__journey}>
        <JourneyConnected journeyId={journeyId} mainJourneyOnly />
      </div>
    </div>
  )
}
